import {Component, OnInit, HostListener, Input, Output, EventEmitter,} from '@angular/core';
import {TravelsService, EventsService, StorageService, WebsocketService} from 'app/services';
import * as moment from 'moment';
import {Location} from '@angular/common';

moment.locale('ru');

@Component({
  selector: 'app-events-calendar',
  templateUrl: './events-calendar.html',
  styleUrls: ['./events-calendar.scss']
})
export class EventsCalendarComponent implements OnInit {

  @Input() displayPeriod = '2weeks';
  @Input() selectedEvent: any = null;
  @Output() dateChange: EventEmitter<any> = new EventEmitter<any>();
  // events: any;
  dayEvents: any;
  travels: any;
  currentDate: any;
  activeDay: any;
  weekStart: any;
  weekEnd: any;
  monthStart: any;
  days: any[];
  calendarTitle: any;
  dates: any[];
  clientID: number;

  constructor(private travelsService: TravelsService,
              private storage: StorageService,
              private location: Location,
              private websocketService: WebsocketService,
              private eventsService: EventsService) {
    this.clientID = this.storage.userId;
  }

  ngOnInit() {
    this.currentDate = this.selectedEvent && this.selectedEvent.timeMoment ? new Date(this.selectedEvent.timeMoment) : new Date();
    this.asyncInit();
    this.websocketService.new_event(this.clientID).subscribe((data) => {
      this.asyncInit();
    });
  }

  async asyncInit(newEvent?) {
    let result = await this.getDayEvents(newEvent);
    await this.getDates(this.currentDate);
    let dayEvents = this.dayEvents.filter(item =>
      item.dayString == moment(this.currentDate).format('DD.MM.YYYY') &&
      item.events && item.events.length > 0
    )[0];

    let day = {
      dayFullDate: moment(this.currentDate),
      dayIsToday: true,
      dayEvents: dayEvents ? dayEvents.events : [],
      dayIsOtherMonth: true
    };

    this.activeDay = day;
    this.dateChange.emit(day || null);
  }


  getDayEvents(newEvent?) {
    let today = moment().startOf('day').format('x');
    return new Promise((resolve, reject) => {
      this.dayEvents = [];
      this.eventsService.getDayEvents({}).subscribe((res) => {
        if (res) {
          this.dayEvents = res.map(day => {
            return {
              ...day,
              events: day.events.map(event => {
                return {...event, isOpened: this.selectedEvent && event.id == this.selectedEvent.id}
              })
            }
          });
          const days = this.dayEvents.filter(item => {
            return Number(today) === Number(item.dayStamp);
          });
          let dayEvents = days && days.length ? days[0].events.length : 0;
          let diff = this.storage.travelHideCounter ? dayEvents - this.storage.travelHideCounter : dayEvents;
          if (newEvent?.travel) {
            //this.storage.travelCounter += diff;
            //this.storage.travelHideCounter = dayEvents;
          } else if (!newEvent && (diff > 0 || !this.storage.travelHideCounter)) {
            //this.storage.travelCounter = diff;
            //this.storage.travelHideCounter = dayEvents;
          } else if (this.location.path() === '/events') {
            //this.storage.travelCounter = 0;
          }
          resolve(true);
        }
      }, (err) => {
        console.log('err', err);
        reject(true);
      });
    });
  }

  getWeeksDates() {
    this.weekStart = moment(this.currentDate).clone().startOf('isoWeek');
    this.weekEnd = moment(this.currentDate).clone().endOf('isoWeek');

    this.dates = [];

    let periodEnd = 0;
    switch (this.displayPeriod) {
      case 'week':
        periodEnd = 7;
        break;
      case '2weeks':
        periodEnd = 14;
        break;
    }

    for (let i = 0; i < periodEnd; i++) {
      let dayFullDate = this.displayPeriod === 'month' ? moment(this.monthStart).add(i, 'days') : moment(this.weekStart).add(i, 'days');
      let dayEvents = this.dayEvents.filter(item =>
        item.dayString == dayFullDate.format('DD.MM.YYYY') &&
        item.events && item.events.length > 0
      )[0];
      let dayIsToday = dayFullDate.isSame(moment(), 'day');

      let dayItem = {
        dayNumberInMonth: dayFullDate.format("D"),
        dayFullDate: dayFullDate,
        dayIsToday: dayIsToday,
        dayEvents: dayEvents ? dayEvents.events : [],
      }

      this.dates.push(dayItem);
      if (dayIsToday) {
        this.dateChange.emit(dayItem || null);
      }

    }
  }

  getMonthDates(date: Date) {
    this.calendarTitle = moment(date).format('MMMM YYYY');
    const now = moment(date).startOf('month');
    const firstOfMonth = moment(date).startOf('month');
    // console.log('!!!!00000000 firstOfMonth', firstOfMonth)
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDayNumber = (new Date(year, month, 1).getDay() || 7) - 1;
    const totalDays = this.getTotalsDays(year, month);
    const totalLast = this.getTotalsDays(year, month - 1);
    const datesMap = [];
    let i = 1 - firstDayNumber;
    let lastItem;
    while (i <= totalDays) {
      if (!datesMap.length || datesMap[datesMap.length - 1].length === 7) {
        datesMap.push([]);
      }
      lastItem = datesMap[datesMap.length - 1];
      if (i <= 0) {
        let dayFullDate = firstOfMonth.clone().add(i - 1, 'days');
        // console.log('!!!!111111111 dayFullDate', dayFullDate)

        let dayEvents = this.dayEvents.filter(item =>
          item.dayString == dayFullDate.format('DD.MM.YYYY') &&
          item.events && item.events.length > 0
        )[0];
        let dayIsToday = dayFullDate.isSame(moment(), 'day');

        lastItem.push(
          [totalLast + i, 'last', +dayFullDate.format('X000'),
            {
              dayFullDate: dayFullDate,
              dayIsToday: dayIsToday,
              dayEvents: dayEvents ? dayEvents.events : [],
              dayIsOtherMonth: true
            }
          ],
        );
      } else {

        let dayFullDate = now.clone();
        let dayEvents = this.dayEvents.filter(item =>
          item.dayString == dayFullDate.format('DD.MM.YYYY') &&
          item.events && item.events.length > 0
        )[0];
        let dayIsToday = dayFullDate.isSame(moment(), 'day');

        lastItem.push(
          [i, 'current', +now.format('X000'),
            {
              dayFullDate: dayFullDate,
              dayIsToday: dayIsToday,
              dayEvents: dayEvents ? dayEvents.events : [],
              dayIsOtherMonth: false
            }
          ]
        );
        now.add(1, 'days');
      }
      i++;
    }

    const lastLength = lastItem.length;
    for (let j = 1; j < (8 - lastLength); j++) {
      let dayFullDate = now.clone();
      let dayEvents = this.dayEvents.filter(item =>
        item.dayString == dayFullDate.format('DD.MM.YYYY') &&
        item.events && item.events.length > 0
      )[0];
      let dayIsToday = dayFullDate.isSame(moment(), 'day');
      lastItem.push(
        [j, 'next', +now.format('X000'),
          {
            dayFullDate: dayFullDate,
            dayIsToday: dayIsToday,
            dayEvents: dayEvents ? dayEvents.events : [],
            dayIsOtherMonth: true
          }
        ]
      );
      now.add(1, 'days');
    }
    this.dates = datesMap;
  }

  onDayClick(day: any) {
    this.activeDay = day;
    if (this.displayPeriod !== '2weeks') {
      this.storage.travelCounter = 0;
    }
    this.dateChange.emit(day || null);
  }

  getTotalsDays(year: number, month: number) {
    return new Date(year, month + 1, 0).getDate();
  }

  getDates(date: Date) {
    if (this.displayPeriod === 'month') {
      this.getMonthDates(date);
    } else {
      this.getWeeksDates();
    }
  }

  changeMonth(isNext?: boolean) {
    if (this.displayPeriod !== '2weeks') {
      this.storage.travelCounter = 0;
    }
    if (isNext) {
      this.currentDate.setMonth(this.currentDate.getMonth() + 1);
    } else {
      this.currentDate.setMonth(this.currentDate.getMonth() - 1);
    }
    this.getDates(this.currentDate);
  }

}
